

export default function (state, value) {
    if (!value) return;
    let date = new Date();
    //state.menu.color = ; TODO: Нет данных
    state.menu.background = value.MenuBackground;

    state.menu.item.color = value.MenuItemFontColor;
    state.menu.item.background = value.MenuItemBackground;
    state.menu.itemHover.color = value.MenuItemFontColor;//TODO: Нет данных
    state.menu.itemHover.background = value.MenuItemBlurBackground;
    state.menu.itemActive.color = value.MenuItemSelectedFontColor;
    state.menu.itemActive.background = value.MenuItemSelectedBackground;

    state.footer.color = value.MenuItemFontColor;//TODO: Нет данных
    state.footer.background = value.FooterColor;
    state.footer.text = value.FooterContent;

}